import axios from 'lib/axios'

const test360FinishTest = async (userTestId: number) => {
  const apiUrl = `/test360/finish/answers`

  try {
    const response = await axios.post(apiUrl, { user_test_id: userTestId })
    return response.data
  } catch (error) {
    console.error('error finishing test 360', error)
  }
}

export default test360FinishTest
